"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setFluidProps = void 0;
const setFluidProps = (node, properties) => {
    const applyProperties = () => {
        Object.entries(properties).forEach(([k, v]) => {
            node[k] = v;
        });
    };
    applyProperties();
    return {
        update(updatedProperties) {
            properties = updatedProperties;
            applyProperties();
        },
    };
};
exports.setFluidProps = setFluidProps;
